var PalantirTextModule = /** @class */ (function () {
    function PalantirTextModule() {
    }
    return PalantirTextModule;
}());
export { PalantirTextModule };
